// Other imports
import Resources from './resources';

class ErrorHandling {
    static addResourceResponseErrorInterceptor(dispatch) {
        // The interceptor needs access to dispatch() so that it can
        // initiate the opening of a model dialog, so we bind it in
        // as the first parameter.

        const interceptor = ErrorHandling.handleErrors.bind(this, dispatch);

        Resources.env.addResponseInterceptor(interceptor);
    }

    // This is a function that looks at the response status and interact accordingly
    static handleErrors(dispatch, result) {
        let valid = true;

        switch (result.status) {
            case 0: // OPTIONS ERROR
            case 400:
            case 401: // BE expired token
            case 403: // FORBIDDEN ERROR
            case 404: // NOT FOUND
            case 409: // CONFLICT ERROR
            case 500: // SERVER ERROR
                valid = false;
                break;
            default:
        }

        result.valid = valid;

        return result;
    }
}

export default ErrorHandling;




// WEBPACK FOOTER //
// ./helpers/error-handling.js